// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPreOrderSwitchDto } from './IPreOrderSwitchDto';
import {
    IPreOrderSwitchDtoFromJSON,
    IPreOrderSwitchDtoFromJSONTyped,
    IPreOrderSwitchDtoToJSON,
    IPreOrderSwitchDtoToJSONTyped,
} from './IPreOrderSwitchDto';

/**
 * 
 * @export
 * @interface IInvestmentModelSwitchDto
 */
export interface IInvestmentModelSwitchDto {
    /**
     * 
     * @type {string}
     * @memberof IInvestmentModelSwitchDto
     */
    new_investment_type: IInvestmentModelSwitchDtoNewInvestmentTypeEnum;
    /**
     * 
     * @type {Set<IPreOrderSwitchDto>}
     * @memberof IInvestmentModelSwitchDto
     */
    pre_orders?: Set<IPreOrderSwitchDto>;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentModelSwitchDto
     */
    risk_tolerance_model?: IInvestmentModelSwitchDtoRiskToleranceModelEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentModelSwitchDto
     */
    investment_amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum IInvestmentModelSwitchDtoNewInvestmentTypeEnum {
    MANAGED = 'MANAGED',
    BROKERAGE = 'BROKERAGE',
    SELF_DIRECTED = 'SELF_DIRECTED'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentModelSwitchDtoRiskToleranceModelEnum {
    CONSERVATIVE = 'CONSERVATIVE',
    MODERATELY_CONSERVATIVE = 'MODERATELY_CONSERVATIVE',
    MODERATE = 'MODERATE',
    MODERATELY_AGGRESSIVE = 'MODERATELY_AGGRESSIVE',
    AGGRESSIVE = 'AGGRESSIVE'
}


/**
 * Check if a given object implements the IInvestmentModelSwitchDto interface.
 */
export function instanceOfIInvestmentModelSwitchDto(value: object): value is IInvestmentModelSwitchDto {
    if (!('new_investment_type' in value) || value['new_investment_type'] === undefined) return false;
    return true;
}

export function IInvestmentModelSwitchDtoFromJSON(json: any): IInvestmentModelSwitchDto {
    return IInvestmentModelSwitchDtoFromJSONTyped(json, false);
}

export function IInvestmentModelSwitchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentModelSwitchDto {
    if (json == null) {
        return json;
    }
    return {
        
        'new_investment_type': json['new_investment_type'],
        'pre_orders': json['pre_orders'] == null ? undefined : (new Set((json['pre_orders'] as Array<any>).map(IPreOrderSwitchDtoFromJSON))),
        'risk_tolerance_model': json['risk_tolerance_model'] == null ? undefined : json['risk_tolerance_model'],
        'investment_amount': json['investment_amount'] == null ? undefined : json['investment_amount'],
    };
}

export function IInvestmentModelSwitchDtoToJSON(json: any): IInvestmentModelSwitchDto {
    return IInvestmentModelSwitchDtoToJSONTyped(json, false);
}

export function IInvestmentModelSwitchDtoToJSONTyped(value?: IInvestmentModelSwitchDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'new_investment_type': value['new_investment_type'],
        'pre_orders': value['pre_orders'] == null ? undefined : (Array.from(value['pre_orders'] as Set<any>).map(IPreOrderSwitchDtoToJSON)),
        'risk_tolerance_model': value['risk_tolerance_model'],
        'investment_amount': value['investment_amount'],
    };
}

